/* eslint-disable no-shadow */
import React, { FunctionComponent, Fragment } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import {
  handlePdfExportOptions,
  handleSelectAll,
  handleUnselectAll,
} from "../../../actions/employerAnalyticsActions";
import pdfExportOptionsTypes from "../types/pdfExportOptionsTypes";
import {
  CheckBoxInput,
  CheckBoxLabel,
  CheckBoxesGroup,
  CheckBoxesGroupItem,
  Indicator,
} from "../styles/export-pdf-modal-styles";

interface IOptionItemProps {
  id: number;
  value: string;
  type: string;
  isChecked: boolean;
  label: string;
}

export interface IAgencyPerformanceOptionsProps {
  options: Array<IOptionItemProps>;
  handlePdfExportOptions: (checkboxName: string) => void;
  handleSelectAll: (userType: string) => void;
  handleUnselectAll: () => void;
  allSelected: boolean;
}

export const AgencyPerformanceOptions: FunctionComponent<
  IAgencyPerformanceOptionsProps
> = ({
  options,
  handlePdfExportOptions,
  handleSelectAll,
  handleUnselectAll,
  allSelected,
}) => (
  <Fragment>
    {allSelected ? (
      <CheckBoxLabel>
        <CheckBoxInput
          type="checkbox"
          checked={allSelected}
          onChange={handleUnselectAll}
        />
        Unselect All
        <Indicator />
      </CheckBoxLabel>
    ) : (
      <CheckBoxLabel>
        <CheckBoxInput
          type="checkbox"
          checked={allSelected}
          onChange={() => handleSelectAll("agency")}
        />
        Select All
        <Indicator />
      </CheckBoxLabel>
    )}
    <CheckBoxesGroup>
      {options.map((option) => {
        if (option.type === "agency") {
          return (
            <CheckBoxesGroupItem key={option.id}>
              <CheckBoxLabel>
                <CheckBoxInput
                  type="checkbox"
                  value={option.value}
                  checked={option.isChecked}
                  onChange={(e) => {
                    handlePdfExportOptions(e.target.value);
                  }}
                />
                {option.label}
                <Indicator />
              </CheckBoxLabel>
            </CheckBoxesGroupItem>
          );
        }
        return null;
      })}
    </CheckBoxesGroup>
  </Fragment>
);

AgencyPerformanceOptions.propTypes = {
  handlePdfExportOptions: PropTypes.func.isRequired,
  handleSelectAll: PropTypes.func.isRequired,
  handleUnselectAll: PropTypes.func.isRequired,
  options: pdfExportOptionsTypes.isRequired,
  allSelected: PropTypes.bool.isRequired,
};

interface IReduxState {
  employerAnalytics: {
    pdfExportOptions: {
      options: Array<IOptionItemProps>;
      allSelected: boolean;
    };
  };
}

const mapStateToProps = (state: IReduxState) => ({
  options: state.employerAnalytics.pdfExportOptions.options,
  allSelected: state.employerAnalytics.pdfExportOptions.allSelected,
});

export default connect(mapStateToProps, {
  handlePdfExportOptions,
  handleSelectAll,
  handleUnselectAll,
})(AgencyPerformanceOptions);
